module.exports = "<nvd3 options=\"ctrl.chartOptions\" data=\"ctrl.chartData\" api=\"chartApi\" nv-tooltip></nvd3>";